"use strict";
exports.__esModule = true;
var angular = require("angular");
var DIRECTIVE_NAME = 'smartorg.r6.navs.contextMenu';
angular.module(DIRECTIVE_NAME, []).directive('context', [function () {
        return {
            restrict: "A",
            compile: function compile() {
                return {
                    post: function postLink(scope, iElement, iAttrs) {
                        var ul = $('#' + iAttrs.context), last = null;
                        ul.css({
                            'display': 'none'
                        });
                        $(iElement).bind('contextmenu', function (event) {
                            event.preventDefault();
                            ul.css({
                                position: "fixed",
                                display: "block",
                                left: event.clientX + 'px',
                                top: event.clientY + 'px'
                            });
                            last = event.timeStamp;
                        });
                        $(document).click(function (event) {
                            var target = $(event.target);
                            if (!target.is(".popover") && !target.parents().is(".popover")) {
                                if (last === event.timeStamp)
                                    return;
                                ul.css({
                                    'display': 'none'
                                });
                            }
                        });
                    }
                };
            }
        };
    }
]);
exports["default"] = DIRECTIVE_NAME;
//# sourceMappingURL=context-menu-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/context-menu/context-menu-directive.js